"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChoiceBox = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
exports.PublicChoiceBox = react_1.default.memo(({ defaultHide, setHide }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [list, setList] = react_1.default.useState([
        { id: '1', title: '공개', checked: false },
        { id: '2', title: '비공개', checked: false },
    ]);
    react_1.default.useEffect(() => {
        setList(list.map(item => ({ ...item, checked: item.id === (defaultHide ? '2' : '1') })));
    }, [defaultHide]);
    return (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.isPublic')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.CheckBox, { isRadioButton: true, list: list, handlerCheck: item => {
                    setHide(item === '2' ? true : false);
                } }))));
});
